import { ref, computed } from 'vue'
import { api } from '@/helpers/api'
import { useAuth } from '@/composables/auth/useAuth'

const URLS = {
    icons: {
        mediaUploadBtn: '/images/icons/media-upload-btn.svg'
    },
    xhr: {
        fetch: {
            media: {
                artist: '/api/profile/v1/user-profile/artist-medias',
                venue: '/api/profile/v1/user-profile/venue-medias'
            }
        },
        mutate: {
            media: '/api/profile/update-media',
            avatar: '/api/profile/update-avatar',
            avatarUpdateExistingMedia: '/api/profile/check-main-media'
        }
    }
}

const medias = ref([])
const profileImgIndx = ref(0)

export const useMediaUploader = () => {
    const { userValues } = useAuth()
    const mediaUploadEl = ref(null)

    const previewSrc = computed(() => (media) => {
        if (media instanceof File) {
            return URL.createObjectURL(media)
        } else {
            return media.src
        }
    })

    ;(() => _populateMedia())()

    function handleMediaUpload(e) {
        if (!e.target.files.length) return
        medias.value.push(e.target.files[0])
    }
    function handleUploadMedia() {
        mediaUploadEl.value.click()
    }
    function handleSelectProfileImg(indx) {
        profileImgIndx.value = indx
    }
    async function updateProfileMedia(data, role, { avatarUpload }) {
        data = _prepMediaData(data, avatarUpload)
        if (!data.getAll('files[]').length) return

        return await api({
            method: 'post',
            url: `${URLS.xhr.mutate.media}/${userValues.value.id}/${role}`,
            data
        })
    }
    async function updateProfileAvatar(role) {
        if (!medias.value.length) return

        const selectedAvatar = medias.value[profileImgIndx.value]

        if (selectedAvatar.id) {
            return await api({
                method: 'post',
                url: `${URLS.xhr.mutate.avatarUpdateExistingMedia}/${userValues.value.id}/${role}`,
                data: {
                    _method: 'PUT',
                    id: selectedAvatar.id
                }
            })
        } else {
            return await api({
                method: 'post',
                url: `${URLS.xhr.mutate.avatar}/${role}/${userValues.value.id}`,
                data: _prepMediaData([selectedAvatar], true)
            })
        }
    }

    function _populateMedia() {
        medias.value = userValues.value.medias
    }
    function _prepMediaData(data, avatarUpload) {
        if (avatarUpload && !(data[0] instanceof File) && data[0].id) {
            return {
                avatar_id: data[0].id,
                _method: 'PUT'
            }
        }

        let formData = new FormData()

        for (let i = 0; i < data.length; i++) {
            if (!avatarUpload && i === profileImgIndx.value) continue

            if (data[i] instanceof File) {
                formData.append('files[]', data[i])
            }
        }

        formData.append('_method', 'PUT')
        return formData
    }
    return {
        URLS,
        mediaUploadEl,
        medias,
        profileImgIndx,
        previewSrc,

        handleUploadMedia,
        handleMediaUpload,
        handleSelectProfileImg,
        updateProfileMedia,
        updateProfileAvatar
    }
}
